import type { Adequation, SaisiePositionnement } from '../../lib/useMatching';
import { MatchingDetailPanel } from './MatchingDetailPanel';
import { FormulairePositionnement } from '../immersion/FormulairePositionnement';
import { LienOrganisation } from '../repertoire/LienOrganisation';

export function PropositionDetail({
  proposition,
  onPositionner,
  enCours,
}: {
  proposition: Adequation;
  onPositionner: (saisie: SaisiePositionnement) => void;
  enCours: boolean;
}) {

  return (
    <div className="rounded-xl bg-white p-4 sm:p-5 shadow-sm border border-gray-100 flex flex-col gap-2">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <LienOrganisation
              id={proposition.entrepriseId}
              nom={proposition.entrepriseNom}
              className="font-bold text-base text-codialis-navy"
              classeLien="hover:text-codialis-sky transition"
            />
            <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-700 rounded-full font-medium">
              {proposition.placesRestantes} place(s) restante(s)
            </span>
          </div>
          <div className="text-sm text-codialis-gray flex gap-2 items-center">
            <span className="font-medium text-codialis-navy">{proposition.posteRecherche || 'Poste non précisé'}</span>
            <span>•</span>
            <span>{proposition.formationCode || 'Formation non précisée'}</span>
          </div>
        </div>

        <div className="flex flex-col items-end gap-1">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-black text-codialis-navy">{proposition.scoreNormalise}</span>
            <span className="text-sm font-bold text-gray-400">/ 100</span>
          </div>
        </div>
      </div>

      <MatchingDetailPanel adequation={proposition} />

      <div className="mt-2 border-t border-gray-100 pt-3">
        <FormulairePositionnement enCours={enCours} onValider={onPositionner} />
      </div>
    </div>
  );
}
